import React, { useEffect, useState } from 'react';
import FeatureUnderDevelopment from '../../../loaders/FeatureUnderDevelopment';
import Head from '../../../../layout/head/Head';
import Content from '../../../../layout/content/Content';
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button } from '../../../../components/Component';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import * as app_consts from '../../../../utils/app_consts';
import { useDispatch } from 'react-redux';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_tenant_dashboard_data, loading_retrieve_tenant_dashboard_data, reset_retrieve_tenant_dashboard_data, success_retrieve_tenant_dashboard_data } from '../../../../reducers/auth_tenant/retrieve_tenant_dashboard_data_Slice';
import { TENANT_RETRIEVE_PROMOTION_DASHBOARD_DATA_API } from '../../../../api/api_data';
import { RETRIEVE_TENANT_DASHBOARD_DATA_ERROR_MSG, RETRIEVE_TENANT_DASHBOARD_DATA_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../utils/Utils';
import PromotionDashboardDataOverview from './promotions_dashboard_data/PromotionDashboardDataOverview';
import { Row } from 'reactstrap';
import PromotionEntriesStatistics from './promotions_dashboard_data/PromotionEntriesStatistics';
import RecentPromotionEntries from './promotions_dashboard_data/RecentPromotionEntries';
import PromotionsMNOsStatistics from './promotions_dashboard_data/PromotionsMNOsStatistics';

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const PromotionsDashboard = ({ tenant_info, user_info }) => {

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page_data, setPageData] = useState([]);


  useEffect(() => {
    retrieve_dashboard_data();
  }, []);

  const retrieve_dashboard_data = () => {
    setError('');
    setLoading(true);
    dispatch(
      tenant_auth_actions_helper(
        loading_retrieve_tenant_dashboard_data,
        success_retrieve_tenant_dashboard_data,
        fail_retrieve_tenant_dashboard_data,
        RETRIEVE_TENANT_DASHBOARD_DATA_ERROR_MSG,
        RETRIEVE_TENANT_DASHBOARD_DATA_SUCCESS_MSG,
        app_consts.GET,
        `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_DASHBOARD_DATA_API}`
      )
    );
  };

  const retrieve_tenant_dashboard_data_listener = useSelector(
    (state) =>
      state.retrieve_tenant_dashboard_data.retrieve_tenant_dashboard_data
  );

  useEffect(() => {
    if (retrieve_tenant_dashboard_data_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_dashboard_data_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError('');
      } else
      {
        if (retrieve_tenant_dashboard_data_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_dashboard_data_listener.message);
          messageToast(
            retrieve_tenant_dashboard_data_listener.message,
            app_consts.FAIL
          );
        } else if (
          retrieve_tenant_dashboard_data_listener.status === app_consts.SUCCESS
        )
        {
          setPageData(retrieve_tenant_dashboard_data_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 600);
          return () => clearTimeout(timer);
        }
        dispatch(reset_retrieve_tenant_dashboard_data());
      }
    }
  }, [retrieve_tenant_dashboard_data_listener]);


  return (
    <>
      <Head
        title={
          tenant_info?.name ? `${tenant_info.name} Promotions Dashboard` : ' Promotions Dashboard'
        }
      />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Promotions Dashboard</BlockTitle>
              {!loading && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.4 }}
                  className="mt-2"
                >
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_dashboard_data();
                    }}
                  >
                    <Button
                      color="light"
                      outline
                      className="bg-white d-none d-sm-inline-flex"
                    >
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </motion.div>
              )}
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>



        <AnimatePresence mode="wait">
          {loading ? (
            <motion.div
              key="loader"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <AuthTenantLoader
                tenant_info={tenant_info}
                loading_message="Loading Promotions Dashboard Info..."
              />
            </motion.div>
          ) : error ? (
            <motion.div
              key="error"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
            >
              <AuthTenantPageError
                tenant_info={tenant_info}
                error_message={error}
              />
            </motion.div>
          ) : page_data && page_data !== null ? (
            <motion.div
              key="data"
              variants={containerVariants}
              initial="hidden"
              animate="show"
              exit="hidden"
            >
              <Block>
                <Row className="g-gs">
                  <motion.div variants={itemVariants} className="col-xxl-4 col-md-6">
                    <PromotionDashboardDataOverview data={page_data} />
                  </motion.div>

                  <motion.div variants={itemVariants} className="col-xxl-8 col-md-6">
                    <PromotionEntriesStatistics data={page_data} />
                  </motion.div>

                  <motion.div variants={itemVariants} className="col-xxl-8">
                    <RecentPromotionEntries
                      data={page_data?.recent_five_entries}
                      tenant_info={tenant_info}
                    />
                  </motion.div>

                  <motion.div variants={itemVariants} className="col-xxl-4 col-md-6">
                    <PromotionsMNOsStatistics data={page_data} />
                  </motion.div>
                </Row>
              </Block>

            </motion.div>
          )
            :
            <>
              <motion.div
                key="nodata"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <AuthTenantNoData
                  tenant_info={tenant_info}
                  no_data_message={'No Data Found'}
                />
              </motion.div>
            </>
          }
        </AnimatePresence>
      </Content>
    </>
  );
};

export default PromotionsDashboard;